import { computed, type MaybeRefOrGetter, toValue } from 'vue'

// Форматирование числа очков для виджета «Вы набрали N» (см. functional/01-overview.md
// → раздел «Универсальные элементы UI»). Разделитель тысяч — неразрывный пробел,
// чтобы число не переносилось на новую строку.
const NUMBER_FORMATTER = new Intl.NumberFormat('ru-RU')

export const usePickemCounter = (
  xp: MaybeRefOrGetter<number | null | undefined>
) => {
  const value = computed(() => toValue(xp) ?? 0)
  const formatted = computed(() => NUMBER_FORMATTER.format(value.value))

  return { value, formatted }
}
